const Index = () => import("./index.vue");
const CreatePage = () => import("./_pages/create.vue");

export default [
  {
    path: "/sms-report",
    name: "SmsPage",
    component: Index,
  },
  {
    path: "/send-sms",
    name: "SendSmsPage",
    component: CreatePage,
  },
];
